import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { storageUrlClean } from '../../../../../../apps/core/src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class TokenInterceptorService implements HttpInterceptor {

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {

    if (req.url.includes(storageUrlClean)) {
      // ako je u pitanju storage url, ne treba da postavljamo token
      return next.handle(req);
    }

    const jwtToken = localStorage.getItem('eKompanija_token');
    if (jwtToken) {
      req = req.clone({
        setHeaders: {
          Authorization: `Bearer ${jwtToken}`,
        },
      });

      return next.handle(req);
    }

    // fallback if we dont have token...
    return next.handle(req);
  }
}
